import { CLEAR_REPORT_TEMP, FETCH_LEDGER_REPORT, FETCH_PERTICULAR_DEBTORS, FETCH_PERTICULAR_REPORT, START_END_DATE } from "src/Helper/actionsTypes";

const LedgerRecieptReducer = (state = [], action) => {
    const { code, results, message } = action.payload || ''
    switch (action.type) {
        case FETCH_LEDGER_REPORT: {
            return code === 200
                ? { ...state, list: results }
                : { ...state, list: [] };
        }
        case FETCH_PERTICULAR_REPORT: {
            return code === 200
            ? { ...state, list: results }
            : { ...state, list: [] };
        }
        case FETCH_PERTICULAR_DEBTORS: {
            return code === 200
            ? { ...state, list: results }
            : { ...state, list: [] };
        }
        case START_END_DATE: {
            return { ...state, date: action.payload }
        }
        case CLEAR_REPORT_TEMP: {
            return { ...state, list: [] }
        }
        default: return state;
    }
}
export default LedgerRecieptReducer